import React from 'react';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';


import ScrollToTop from './ScrollToTop';
// Import your components
import Home from './pages/Home';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Register from './pages/Register';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Legal from './pages/Legal';
import LegalAccessibility from './pages/LegalAccessibility';
import TermsCondition from './pages/TermsCondition';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Career from './pages/Career';
import Resources from './pages/Resources';
import MyAccount from './pages/MyAccount';
import SignupStep from './pages/SignupStep'; 
import ResourcesDetails from './pages/ResourcesDetails';
import ServicePage from './pages/ServicePage';
import FourZeroFourError from './pages/FourZeroFourError';
import FiveZeroZeroError from './pages/FiveZeroZeroError';
import Thankyou from './pages/Thankyou';
import ProtectedRoute from './component/ProtectedRoute';
import ContactUs from './pages/ContactUs';

import ChangePassword from "./pages/ChangePassword";

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Welcome | Helpotani</title>
        <meta name="description" content="This is the default meta description for your website." />
        <meta name="keywords" content="default, keywords, for, your, website" />
      </Helmet>
    <Router> 
      <ScrollToTop />    
        <Routes>
          <Route path="/" element={<Home />} /> 
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<ChangePassword />} />  

          <Route path="/login" element={<Login />} /> 
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />  
        

          <Route path="/about-us" element={<About />} /> 
          <Route path="/contact-us" element={<ContactUs />} /> 
          
          <Route path="/blogs" element={<Blog />} /> 
          <Route path="/blog-details/:slug" element={<BlogDetails />} />
          <Route path="/blog-by-category/:slug" element={<Blog />} />

          <Route path="/service-details/:slug" element={<ServicePage />} />

          <Route path="/resources" element={<Resources />} /> 
          <Route path="/resource-details/:slug" element={<ResourcesDetails />} />
          <Route path="/resource-by-category/:slug" element={<Resources />} />


          <Route path="/career" element={<Career />} /> 

          

          <Route path="/profile" element={<ProtectedRoute element={MyAccount} />} />
          <Route path="/profile/:innerPage" element={<ProtectedRoute element={MyAccount} />} />

          <Route path="/signup-step" element={<SignupStep />} />
          <Route path="/thankyou" element={<Thankyou />} />


          <Route path="/404-error" element={<FourZeroFourError />} />
          <Route path="/500-error" element={<FiveZeroZeroError />} />

         
          <Route path="/legal" element={<Legal />} /> 
          <Route path="/legal-accessibility" element={<LegalAccessibility />} /> 
          <Route path="/terms-condition" element={<TermsCondition />} /> 
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 

          
        </Routes>       
    </Router>
    </HelmetProvider>
  );
}

export default App;
